// extracted by mini-css-extract-plugin
module.exports = {"tab":"a10a3f92e9--tab--OJ7Gg","active":"a10a3f92e9--active--Wmf5T","text":"a10a3f92e9--text--aArm7"};